import React from "react";
import freepikbg from "../../assets/freepik.png";
import createimage from "../../assets/zynthworks1.png";
import evolutionimage from "../../assets/image4.png";
import zynthtext from "../../assets/zynth-text.png";
import { Link, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Blue Background Section */}
      <div
        className="bg-cover bg-center py-16 text-center text-white"
        style={{ backgroundImage: `url(${freepikbg})` }}
      >
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-semibold mb-4">
            Get Started with Zynth{" "}
          </h1>
          <p className="text-lg mb-8 font-semibold">
            More than a simple PowerPoint make Zynth is your personal <br></br>{" "}
            AI presentation creator.
          </p>
          {/* <button
            onClick={() => navigate('/auth')}
            className="bg-yellow-500 text-black font-semibold py-5 px-8 rounded-lg hover:bg-yellow-600 active:scale-95 active:opacity-80 transition-all duration-300"
          >
            Get Started for Free
          </button> */}
        </div>

        {/* Image Section */}
        <div className="container mx-auto px-4 py-12 ">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8">
            <img
              src={createimage}
              alt="Create or Refine Presentation"
              className="w-full md:w-1/2 bg-white rounded-3xl"
            />
            <img
              src={evolutionimage}
              alt="Evolution of Our Path"
              className="w-full md:w-1/2 bg-white rounded-3xl"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row w-full items-center justify-center gap-4">
          <button
            onClick={() => navigate("/auth")}
            className="w-[50%] md:w-[30%]  bg-yellow-500 text-black font-semibold py-5 px-8 rounded-lg hover:bg-yellow-600 active:scale-95 active:opacity-80 transition-all duration-300"
          >
            Get Started for Free
          </button>
          <button
            onClick={() =>
              window.open(
                "https://workspace.google.com/marketplace/app/zynthai/704273243272",
                "_blank"
              )
            }
            className="w-[50%] md:w-[38%] lg:w-[33%] bg-yellow-500 text-black font-semibold py-5 px-8 rounded-lg hover:bg-yellow-600 active:scale-95 active:opacity-80 transition-all duration-300"
          >
            Install Google Slides Extension
          </button>
          <button
            onClick={() => window.open("https://pitch.zynth.ai/", "_blank")}
            className="w-[50%] md:w-[30%] bg-yellow-500 text-black font-semibold py-5 px-8 rounded-lg hover:bg-yellow-600 active:scale-95 active:opacity-80 transition-all duration-300"
          >
            Try Pitch.zynth Now
          </button>
        </div>
      </div>
      {/* Footer Section */}
      <footer className="bg-white py-12">
        <div className="container mx-auto px-4">
          {/* Footer Logo & Text */}
          <div className="flex flex-col md:flex-row justify-between items-start mb-8">
            <div className="text-left mb-6 md:mb-0 md:w-[50%]">
              <img
                src={zynthtext}
                alt="Zynth Logo"
                className="h-10 mb-4 md:mb-2 mx-auto md:mx-0"
              />
              <p className="text-black text-sm">
                Create your investor presentations in a few minutes <br></br> using our
                AI-powered pitch deck builder. No design skills needed.
              </p>
              <p className="text-black text-sm mt-2">
                © {new Date().getFullYear()} Parati Technologies Private
                Limited. All rights reserved.
              </p>
            </div>

            {/* Footer Links - Right Side */}
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 text-left">
              {/* <div>
              <h3 className="font-bold text-gray-800 mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://www.parati.in/about-us"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:underline"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a href="https://www.parati.in/impactdb" target="_blank" className="text-gray-600 hover:underline">
                    Impact DB
                  </a>
                </li>
                <li>
                  <a href="https://www.parati.in/eos" target="_blank" className="text-gray-600 hover:underline">
                    Parati Eos
                  </a>
                </li>
              </ul>
            </div> */}
              {/* <div>
              <h3 className="font-bold text-gray-800 mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="https://www.parati.in/business-strategy" target="_blank"  className="text-gray-600 hover:underline">
                    Business Strategy
                  </a>
                </li>
                <li>
                  <a href="https://www.parati.in/investor-relations" target="_blank"  className="text-gray-600 hover:underline">
                    Investor Relations
                  </a>
                </li>
                <li>
                  <a href="https://www.parati.in/managed-operations" target="_blank" className="text-gray-600 hover:underline">
                    Managed Operations
                  </a>
                </li>
                <li>
                  <a href="https://www.parati.in/digital-transformation" target="_blank" className="text-gray-600 hover:underline">
                    Digital Transformation
                  </a>
                </li>
              </ul>
            </div> */}

              <div>
                <h3 className="font-bold text-gray-800 mb-4">AI Tools</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="#blog"
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/new-presentation", "_blank");
                      }}
                    >
                      AI Presentations
                    </a>
                  </li>
                  <li>
                    <a
                      href="#blog"
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/new-document", "_blank");
                      }}
                    >
                      AI Documents
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="#blog"
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                          window.open("https://pitch.zynth.ai/", "_blank", "noopener,noreferrer");
                      }}
                    >
                      AI Pitch Builder
                    </a>
                  </li> */}
                  <li>
                    <a
                      onClick={() =>
                        window.open(
                          "https://extension.zynth.ai/",
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      Google Slides Add On
                    </a>
                  </li>
                  <li>
                    <a
                      //onClick={() => window.open("https://docs.google.com/document/d/1lBoA1B9l5vXC9c4h7Sm0UOLrhVYWzV-XWQsnbTIU5f4/edit?tab=t.bdrsl1euhj4", "_blank")}
                      onClick={() => window.open("/apiReference", "_blank")}
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      API Reference
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-800 mb-4">Resources</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="https://www.parati.in/about-us"
                      target="_blank"
                      className="text-gray-600 hover:underline whitespace-nowrap"
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="#blog"
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/blog", "_blank");
                      }}
                    >
                      Blog
                    </a>
                  </li>
                  <li>
                    <a
                      //onClick={() => window.open("https://docs.google.com/document/d/1lBoA1B9l5vXC9c4h7Sm0UOLrhVYWzV-XWQsnbTIU5f4/edit?tab=t.bdrsl1euhj4", "_blank")}
                      onClick={() => window.open("/apiReference", "_blank")}
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      API Reference
                    </a>
                  </li>
                  <li>
                    <a
                      href="#pricing"
                      className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open("/pricing", "_blank");
                      }}
                    >
                      Pricing
                    </a>
                  </li>

                  <li>
                    <Link
                      to="/contact-us"
                      className="text-gray-600 hover:underline whitespace-nowrap"
                    >
                      Contact us
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                 <h3 className="font-bold text-gray-800 mb-4"> Use Cases</h3>
                <ul className="space-y-2">
                  {[
                    { name: "Sales ", path: "/use-cases-sales" },
                    { name: "Marketing", path: "/use-cases-marketing" },
                    { name: "Pitch Decks", path: "/use-cases-pitch" },
                    { name: "Employee Engagement",path: "/use-cases-employee"},
                    { name: "Education", path: "/use-cases-education" },
                    { name: "White Label", path: "/white-label" },
                  ].map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.path}
                        className="text-[#5D5F61] hover:text-blue-600 transition-colors duration-200 whitespace-nowrap"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-gray-800 mb-4">Legal</h3>
                <ul className="space-y-2">
                  <li>
                    <a
                      href="/privacy-policy.html"
                      className="text-gray-600 hover:underline whitespace-nowrap"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href="/refund.html"
                      className="text-gray-600 hover:underline whitespace-nowrap"
                      target="_blank"
                    >
                      Refunds and Cancellations
                    </a>
                  </li>
                  <li>
                    <a
                      href="/terms.html"
                      className="text-gray-600 hover:underline whitespace-nowrap"
                      target="_blank"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
